import { API_URL } from '../../environment';
import { ducksActionCreator } from '../ducksHelpers';

export const appointmentSettings = {
  stateName: 'appointment',
  dataType: 'object',
  actions: {
    fetch: 'ducks/schedule/FETCH_APPOINTMENT',
    create: 'ducks/schedule/CREATE_APPOINTMENT',
    update: 'ducks/schedule/UPDATE_APPOINTMENT',
  },
};

// Action Creators
export function fetchAppointment(
  id,
  callback = () => {},
  errorCallback = () => {},
) {
  return ducksActionCreator(
    appointmentSettings.actions.fetch,
    'get',
    `${API_URL}/practice/appointments/${id}`,
    {},
    true,
    callback,
    errorCallback,
  );
}

export function createAppointment(
  values,
  callback = () => {},
  errorCallback = () => {},
) {
  return ducksActionCreator(
    appointmentSettings.actions.create,
    'post',
    `${API_URL}/practice/appointments`,
    { ...values },
    true,
    callback,
    errorCallback,
  );
}

export function updateAppointment(
  id,
  values,
  callback = () => {},
  errorCallback = () => {},
) {
  return ducksActionCreator(
    appointmentSettings.actions.update,
    'put',
    `${API_URL}/practice/appointments/${id}`,
    { ...values },
    true,
    callback,
    errorCallback,
  );
}
